var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.365 4.447-.002-.005A7.24 7.24 0 0 1 5 2.167c0-.551-.45-1-1-1H1.667c-.551 0-1 .449-1 1 0 6.444 5.222 11.666 11.666 11.666.551 0 1-.449 1-1v-2.326c0-.551-.449-1-1-1-.79 0-1.561-.128-2.274-.363a.996.996 0 0 0-1.021.24l-1.293 1.293a9.769 9.769 0 0 1-3.923-3.921l1.294-1.294c.278-.278.358-.669.249-1.015Z",
    stroke: "currentColor",
    strokeWidth: 0.667
  })));
};
export default SvgIconPhone;